import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import isString from 'lodash/isString'

function getProfileValue(profile, extraField) {
  const data = isString(profile[extraField.id])
    ? profile[extraField.id]
    : profile[extraField.id].data
  return extraField.getValue ? extraField.getValue(data) : data
}

const CustomerProfileExtraData = ({
  profile,
  extraFields,
  alignData,
  contentClasses,
}) => {
  return (
    <Fragment>
      {extraFields &&
        extraFields.map(
          (extraField) =>
            extraField &&
            profile[extraField.id] && (
              <tr key={extraField.id}>
                <td>{`${extraField.label || extraField.id}: `}</td>
                <td align={alignData}>
                  <span className={contentClasses}>
                    {getProfileValue(profile, extraField)}
                  </span>
                </td>
              </tr>
            )
        )}
    </Fragment>
  )
}

CustomerProfileExtraData.defaultProps = {
  alignData: 'left',
  contentClasses: 'ml3',
}

CustomerProfileExtraData.propTypes = {
  profile: PropTypes.object.isRequired,
  extraFields: PropTypes.array.isRequired,
  alignData: PropTypes.string,
  contentClasses: PropTypes.string,
}

export default CustomerProfileExtraData
